import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import dayjs from '@/utils/dayjs';
import dayjsSvLocale from 'dayjs/locale/sv';
import { ArticleDate } from './ArticleDate';

export interface StandaloneArticleDateProps extends StandaloneComponentProps {
  publishedDatetime?: string;
  updatedDatetime?: string;
  format?: string;
}

export const StandaloneArticleDate: StandaloneComponent<StandaloneArticleDateProps> = ({
  publishedDatetime,
  updatedDatetime,
  format = 'D MMMM YYYY',
  ...props
}) => {
  const formattedPublishDate = dayjs(publishedDatetime).tz().locale(dayjsSvLocale).format(format);
  const formattedUpdateDate = dayjs(updatedDatetime).tz().locale(dayjsSvLocale).format(format);
  const isoDatetime = dayjs(publishedDatetime).toISOString();

  return (
    <ArticleDate {...props}>
      <ArticleDate.Date dateTime={isoDatetime} suppressHydrationWarning>
        {formattedPublishDate}
      </ArticleDate.Date>

      {updatedDatetime && (
        <ArticleDate.UpdatedDate suppressHydrationWarning>
          &#160;{`UPPDATERAD ${formattedUpdateDate}`}
        </ArticleDate.UpdatedDate>
      )}
    </ArticleDate>
  );
};
